// ✅ OPCIÓN MÚLTIPLE — Parte II §0 y §2 del documento maestro.
//
// Spec visual textual del documento:
//   · "Grid de 2×2 tarjetas grandes (mínimo 120px alto), con ícono + texto corto."
//   · "Al seleccionar, la tarjeta correcta pulsa en verde neón (#00ff94), las
//      incorrectas se atenúan a 40% opacidad — nunca rojo fuerte (mantiene el
//      tono 'no es un castigo')."
import { useState } from 'react';

const LETTERS = ['a', 'b', 'c', 'd'];

export default function SlideOpcionMultiple({ slide, onAnswer, locked }) {
  const [picked, setPicked] = useState(null);

  const handlePick = (opt) => {
    if (picked || locked) return;
    setPicked(opt.id);
    onAnswer(opt.correct);
  };

  return (
    <>
      <p className="ob-subhead">{slide.prompt}</p>

      <div className="ob-choice-grid">
        {slide.options.map((opt, i) => {
          // Tras responder: la correcta pulsa en verde, el resto se atenúa.
          const revealed = picked !== null;
          const cls = revealed
            ? opt.correct
              ? ' ob-correct'
              : ' ob-dimmed'
            : '';

          return (
            <button
              key={opt.id}
              type="button"
              className={`ob-choice${cls}`}
              onClick={() => handlePick(opt)}
              disabled={revealed || locked}
            >
              <span className="ob-choice-letter">{LETTERS[i]}</span>
              <span>{opt.text}</span>
            </button>
          );
        })}
      </div>
    </>
  );
}
